export default __webpack_public_path__ + "locales/el-GR/SendInviteDialog.json?hash=2d58ec3570f77603ad60ab8ca4fd4f57";